import type { LossAndDamageClaimPrintFormInfo } from '@/views/screens/Claims/types';
import { StyleSheet, View } from '@react-pdf/renderer';
import type { FC } from 'react';
import { formateAmount } from '../../../../../utilz';
import { convertUtcToLocal, getDateLabel } from '../../../../../utilz/dates';
import { PDFPage, PDFRow, PDFTable, PDFTableCell, PDFTableRow, PDFText } from '../../components/CommonPdfComponents';

interface LADClaimPDFProps {
  claimDetails: LossAndDamageClaimPrintFormInfo;
}

const LADClaimPDF: FC<LADClaimPDFProps> = ({ claimDetails }) => {
  return (
    <PDFPage paddingVertical={20} paddingHorizontal={12}>
      <View style={{ flex: 1 }}>
        <View style={{ textAlign: 'center', marginBottom: 45, marginTop: 45 }}>
          <PDFText style={styles.title}>PRESENTATION OF LOSS AND DAMAGE CLAIM</PDFText>
        </View>
        <PDFRow>
          <View style={{ flex: 1, paddingRight: 5 }}>
            <View style={{ marginBottom: 12 }}>
              <PDFText style={styles.title2}>Claimant:</PDFText>
              <PDFText style={styles.text}>{claimDetails.customerName}</PDFText>
              <PDFText style={styles.text}>{claimDetails.customerDetailName}</PDFText>
              <PDFText style={styles.text}>{claimDetails.customerDetailAddress}</PDFText>
              <PDFText style={styles.text}>{claimDetails.customerName}</PDFText>
              <PDFText style={styles.text}>{claimDetails.customerDetailPhone}</PDFText>
            </View>
            <View style={{ marginBottom: 15 }}>
              <PDFText style={styles.title2}>
                FORWARD CORRESPONDENCE TO ADDRESS ABOVE AND MAKE CHECK PAYABLE TO :
              </PDFText>
              <PDFText style={styles.text}>{claimDetails.checkPayableTo}</PDFText>
            </View>
            <View style={{ marginBottom: 12 }}>
              <PDFText style={{ ...styles.title2, marginBottom: 4 }}>
                Transportation Provider's Name and Address :
              </PDFText>
              <PDFText style={styles.text}>{claimDetails.carrierName}</PDFText>
              <PDFText style={styles.text}>{claimDetails.carrierAddr1}</PDFText>
              <PDFText style={styles.text}>{claimDetails.carrierAddr2}</PDFText>
              <PDFText style={styles.text}>{claimDetails.carrierCSZ}</PDFText>
            </View>
            <View>
              <PDFRow>
                <View style={{ flex: 1 }}>
                  <PDFRow>
                    <View style={{ flex: 1 }}>
                      <PDFText style={styles.title2}>Pro Number :</PDFText>
                    </View>
                    <View style={{ flex: 1, paddingLeft: 5 }}>
                      <PDFText style={styles.text} preventOverlap>
                        {claimDetails.claimProNo}
                      </PDFText>
                    </View>
                  </PDFRow>
                </View>
                <View style={{ flex: 1 }}>
                  <PDFRow>
                    <View style={{ flex: 1 }}>
                      <PDFText style={styles.title2}>Seal Number :</PDFText>
                    </View>
                    <View style={{ flex: 1, paddingLeft: 5 }}>
                      <PDFText style={styles.text}>{claimDetails.sealNumber}</PDFText>
                    </View>
                  </PDFRow>
                </View>
              </PDFRow>
              <PDFRow>
                <View style={{ flex: 1 }}>
                  <PDFRow>
                    <View style={{ flex: 1 }}>
                      <PDFText style={styles.title2}>Date Shipped :</PDFText>
                    </View>
                    <View style={{ flex: 1, paddingLeft: 5 }}>
                      <PDFText style={styles.text}>{claimDetails.dateShipped}</PDFText>
                    </View>
                  </PDFRow>
                </View>
                <View style={{ flex: 1 }}>
                  <PDFRow>
                    <View style={{ flex: 1 }}>
                      <PDFText style={styles.title2}>Seal Intact :</PDFText>
                    </View>
                    <View style={{ flex: 1, paddingLeft: 5 }}>
                      <PDFText style={styles.text}>{claimDetails.sealIntact}</PDFText>
                    </View>
                  </PDFRow>
                </View>
              </PDFRow>
              <PDFRow>
                <View>
                  <PDFText style={styles.title2}>Transportation Provider's Ack Number :</PDFText>
                </View>
                <View style={{ paddingLeft: 5 }}>
                  <PDFText style={styles.text}>{claimDetails.claimAckNo}</PDFText>
                </View>
              </PDFRow>
              <PDFRow>
                <View>
                  <PDFText style={styles.title2}>Pieces :</PDFText>
                </View>
                <View style={{ paddingLeft: 5 }}>
                  <PDFText style={styles.text}>{claimDetails.claimNoOfPieces}</PDFText>
                </View>
              </PDFRow>
              <PDFRow>
                <View>
                  <PDFText style={styles.title2}>Chargeable Weight :</PDFText>
                </View>
                <View style={{ paddingLeft: 5 }}>
                  <PDFText style={styles.text}>{formateAmount(claimDetails?.cargoShipmentWeight)}</PDFText>
                </View>
              </PDFRow>
            </View>
          </View>
          <View style={{ flex: 1, paddingLeft: 5 }}>
            <PDFText style={styles.title2}>General Claim Information :</PDFText>
            <View style={{ marginVertical: 8 }}>
              <PDFRow>
                <View style={{ flex: 1, paddingHorizontal: 5 }}>
                  <PDFText style={styles.title2}>Claim Number : </PDFText>
                </View>
                <View style={{ flex: 1 }}>
                  <PDFText style={styles.text}>{claimDetails.claimNumber}</PDFText>
                </View>
              </PDFRow>
              <PDFRow>
                <View style={{ flex: 1, paddingHorizontal: 5 }}>
                  <PDFText style={styles.title2}>Date Filed : </PDFText>
                </View>
                <View style={{ flex: 1 }}>
                  <PDFText style={styles.text}>{claimDetails.dateFiled}</PDFText>
                </View>
              </PDFRow>
              <PDFRow>
                <View style={{ flex: 1, paddingHorizontal: 5 }}>
                  <PDFText style={styles.title2}>Claim Amount : </PDFText>
                </View>
                <View style={{ flex: 1 }}>
                  <PDFText style={styles.text}>{claimDetails.claimTotal}</PDFText>
                </View>
              </PDFRow>
              <PDFRow>
                <View style={{ flex: 1, paddingHorizontal: 5 }}>
                  <PDFText style={styles.title2}>Type : </PDFText>
                </View>
                <View style={{ flex: 1 }}>
                  <PDFText style={styles.text}>{claimDetails.claimTypeDesc}</PDFText>
                </View>
              </PDFRow>
              <PDFRow>
                <View style={{ flex: 1, paddingHorizontal: 5 }}>
                  <PDFText style={styles.title2}>Invoice Number : </PDFText>
                </View>
                <View style={{ flex: 1 }}>
                  <PDFText style={styles.text}>{claimDetails.invoiceNo}</PDFText>
                </View>
              </PDFRow>
              <PDFRow>
                <View style={{ flex: 1, paddingHorizontal: 5 }}>
                  <PDFText style={styles.title2}>Accounting Code : </PDFText>
                </View>
                <View style={{ flex: 1 }}>
                  <PDFText style={styles.text}>{claimDetails.acctCode}</PDFText>
                </View>
              </PDFRow>
              <PDFRow>
                <View style={{ flex: 1, paddingHorizontal: 5 }}>
                  <PDFText style={styles.title2}>A/P Number : </PDFText>
                </View>
                <View style={{ flex: 1 }}>
                  <PDFText style={styles.text}>{claimDetails.apNumber}</PDFText>
                </View>
              </PDFRow>
              <PDFRow>
                <View style={{ flex: 1, paddingHorizontal: 5 }}>
                  <PDFText style={styles.title2}>Branch : </PDFText>
                </View>
                <View style={{ flex: 1 }}>
                  <PDFText style={styles.text}>{claimDetails.branchDesc}</PDFText>
                </View>
              </PDFRow>
            </View>
            <View style={{ marginBottom: 20, paddingHorizontal: 5 }}>
              <PDFText style={{ ...styles.title2, marginBottom: 4 }}>Consignee's Name and Address :</PDFText>
              <PDFText style={styles.text}>{claimDetails.consigneeName}</PDFText>
              <PDFText style={styles.text}>{claimDetails.consigneeAddr1}</PDFText>
              {claimDetails.consigneeAddr2 && <PDFText style={styles.text}>{claimDetails.consigneeAddr2}</PDFText>}
              <PDFText style={styles.text}>
                {claimDetails?.consigneeCity}, {claimDetails?.consigneeState} {claimDetails?.consigneeZip}
              </PDFText>
            </View>
            <View style={{ paddingHorizontal: 5 }}>
              <PDFText style={{ ...styles.title2, marginBottom: 4 }}>Shipper's Name and Address :</PDFText>
              <PDFText style={styles.text}>{claimDetails.shipperName}</PDFText>
              <PDFText style={styles.text}>{claimDetails.shipperAddr1}</PDFText>
              {claimDetails.shipperAddr2 && <PDFText style={styles.text}>{claimDetails.shipperAddr2}</PDFText>}
              <PDFText style={styles.text}>
                {claimDetails?.shipperCity}, {claimDetails?.shipperState} {claimDetails?.shipperZip}
              </PDFText>
            </View>
          </View>
        </PDFRow>
        <View style={{ textAlign: 'center', marginBottom: 7 }}>
          <PDFText style={styles.title2}>*****DETAILED CLAIM STATEMENT*****</PDFText>
        </View>
        <View style={{ border: '1px solid black', borderBottom: 'none' }}>
          <PDFTable>
            <PDFTableRow>
              <PDFTableCell width="7.5%">
                <PDFText style={styles.tableHeader}>Quantity</PDFText>
              </PDFTableCell>
              <PDFTableCell width="8%">
                <PDFText style={styles.tableHeader}>Product Code</PDFText>
              </PDFTableCell>
              <PDFTableCell width="10%">
                <PDFText style={styles.tableHeader}>Product Description</PDFText>
              </PDFTableCell>
              <PDFTableCell width="7.5%">
                <PDFText style={styles.tableHeader}>Unit Of Measure</PDFText>
              </PDFTableCell>
              <PDFTableCell width="15%" padding={0}>
                <View style={{ flexDirection: 'column' }}>
                  <View style={{ height: 35, padding: 5 }}>
                    <PDFText style={styles.tableHeader}>Chargeable Weight</PDFText>
                  </View>
                  <View style={{ borderTop: '1px solid black' }}>
                    <PDFRow>
                      <View
                        style={{
                          padding: 5,
                          width: '45%',
                          borderRight: '1px solid black',
                        }}
                      >
                        <PDFText style={styles.tableHeader}>Item Unit Weight</PDFText>
                      </View>
                      <View style={{ padding: 5, width: '55%' }}>
                        <PDFText style={styles.tableHeader}>Total Weight</PDFText>
                      </View>
                    </PDFRow>
                  </View>
                </View>
              </PDFTableCell>
              <PDFTableCell width="23%" padding={0}>
                <View style={{ flex: 1, flexDirection: 'column' }}>
                  <View style={{ height: 35, padding: 5 }}>
                    <PDFText style={{ ...styles.tableHeader, marginTop: 6 }}>Value</PDFText>
                  </View>
                  <View
                    style={{
                      flex: 1,
                      borderTop: '1px solid black',
                    }}
                  >
                    <PDFRow style={{ flex: 1 }}>
                      <View
                        style={{
                          paddingVertical: 5,
                          paddingHorizontal: 1,
                          width: '37%',
                          borderRight: '1px solid black',
                        }}
                      >
                        <PDFText style={styles.tableHeader}>Full / Release Value</PDFText>
                      </View>
                      <View
                        style={{
                          padding: 5,
                          width: '32%',
                          borderRight: '1px solid black',
                        }}
                      >
                        <PDFText style={styles.tableHeader}>Value / Each</PDFText>
                      </View>
                      <View style={{ padding: 5, width: '31%' }}>
                        <PDFText style={styles.tableHeader}>Total Value</PDFText>
                      </View>
                    </PDFRow>
                  </View>
                </View>
              </PDFTableCell>
              <PDFTableCell width="15%" padding={0}>
                <View style={{ flex: 1, flexDirection: 'column' }}>
                  <View style={{ height: 35, padding: 5 }}>
                    <PDFText style={{ ...styles.tableHeader, marginTop: 6 }}>Mitigated</PDFText>
                  </View>
                  <View
                    style={{
                      flex: 1,
                      borderTop: '1px solid black',
                    }}
                  >
                    <PDFRow style={{ flex: 1 }}>
                      <View
                        style={{
                          padding: 5,
                          width: '70%',
                          borderRight: '1px solid black',
                        }}
                      >
                        <PDFText style={styles.tableHeader}>Percentage / Value</PDFText>
                      </View>
                      <View
                        style={{
                          paddingHorizontal: 1,
                          paddingVertical: 5,
                          width: '30%',
                        }}
                      >
                        <PDFText style={styles.tableHeader}>Type</PDFText>
                      </View>
                    </PDFRow>
                  </View>
                </View>
              </PDFTableCell>
              <PDFTableCell width="7.5%">
                <PDFText style={styles.tableHeader}>Amount</PDFText>
              </PDFTableCell>
              <PDFTableCell borderRight={false} width="9%">
                <PDFText style={styles.tableHeader}>Claim Amount</PDFText>
              </PDFTableCell>
            </PDFTableRow>
            {claimDetails.claimItem.map((item) => (
              <PDFTableRow key={item.itemSeq}>
                <PDFTableCell padding={1} width="7.43%">
                  <PDFText style={styles.text}>{item?.itemQuantity}</PDFText>
                </PDFTableCell>
                <PDFTableCell padding={1} width="7.93%">
                  <PDFText style={styles.text} preventOverlap>
                    {item?.itemCode}
                  </PDFText>
                </PDFTableCell>
                <PDFTableCell padding={1} width="9.90%">
                  <PDFText style={styles.text}>{item?.itemDesc}</PDFText>
                </PDFTableCell>
                <PDFTableCell padding={1} width="7.43%">
                  <PDFText style={styles.text}>{item?.uomDesc}</PDFText>
                </PDFTableCell>
                <PDFTableCell padding={1} width="6.72%">
                  <PDFText style={styles.text}>{formateAmount(item?.itemUnitWeight)}</PDFText>
                </PDFTableCell>
                <PDFTableCell padding={1} width="8.3%">
                  <PDFText style={styles.text}>{formateAmount(item?.totalWeight)}</PDFText>
                </PDFTableCell>
                <PDFTableCell padding={1} width="8.45%">
                  <PDFText style={styles.text}>{item?.fullRelFlag === 'F' ? 'Full' : 'Release'}</PDFText>
                </PDFTableCell>
                <PDFTableCell padding={1} width="7.38%">
                  <PDFText style={styles.text}>{formateAmount(item?.value)}</PDFText>
                </PDFTableCell>
                <PDFTableCell padding={1} width="7.31%">
                  <PDFText style={styles.text}>{formateAmount(item?.totalValue)}</PDFText>
                </PDFTableCell>
                <PDFTableCell padding={1} width="10.31%">
                  <PDFText style={styles.text}>
                    {item.smType === 'P' && item.smAmount != null && item.smAmount > 0
                      ? '%'
                      : item.smType === 'A' && item.smAmount != null && item.smAmount > 0
                        ? '$'
                        : ''}
                  </PDFText>
                </PDFTableCell>
                <PDFTableCell padding={1} width="4.75%">
                  <PDFText style={styles.text}>{item?.smFlag}</PDFText>
                </PDFTableCell>
                <PDFTableCell padding={1} width="7.45%">
                  <PDFText style={styles.text}>{formateAmount(item?.smAmount)}</PDFText>
                </PDFTableCell>
                <PDFTableCell padding={1} style={{ flex: 1 }} borderRight={false}>
                  <PDFText style={styles.text}>{formateAmount(item?.productClaimAmount)}</PDFText>
                </PDFTableCell>
              </PDFTableRow>
            ))}
          </PDFTable>
        </View>
        <View
          style={{
            flexDirection: 'row',
            justifyContent: 'space-between',
            display: 'flex',
            marginTop: 5,
          }}
        >
          <View style={{ flex: 1 }}>
            <PDFText style={styles.title2}>Notes :</PDFText>
            <View style={{ marginTop: 10, marginRight: 10 }}>
              {claimDetails?.claimComment
                ?.filter((note) => note.commentType !== 'I')
                .map((note, key) => (
                  // biome-ignore lint/suspicious/noArrayIndexKey: <explanation>
                  <PDFRow key={key} gutter={15} style={{ marginBottom: 3 }}>
                    <View>
                      <PDFText style={styles.text}>{getDateLabel(convertUtcToLocal(note.createdOn))}</PDFText>
                    </View>
                    <View style={{ marginLeft: 10 }}>
                      <PDFText preventOverlap style={styles.text}>
                        {note.commentText}
                      </PDFText>
                    </View>
                  </PDFRow>
                ))}
            </View>
          </View>
          <View>
            <PDFRow>
              <View style={{ width: 135 }}>
                <PDFText style={styles.title2}>+ Freight Cost (pro-rated):</PDFText>
              </View>
              <View>
                <PDFText style={styles.text}>{formateAmount(claimDetails?.freightChargeClaimed)}</PDFText>
              </View>
            </PDFRow>
            <PDFRow>
              <View style={{ width: 135 }}>
                <PDFText style={styles.title2}>
                  + Labor Cost ({Number(claimDetails?.laborHours).toFixed(2)} Hours):
                </PDFText>
              </View>
              <View>
                <PDFText style={styles.text}>{formateAmount(claimDetails?.laborCharge)}</PDFText>
              </View>
            </PDFRow>
            <PDFRow>
              <View style={{ width: 135 }}>
                <PDFText style={styles.title2}>+ Additional Cost :</PDFText>
              </View>
              <View>
                <PDFText style={styles.text}>{formateAmount(claimDetails?.claimAddCharge)}</PDFText>
              </View>
            </PDFRow>
            <PDFRow>
              <View style={{ width: 135 }}>
                <PDFText style={styles.title2} preventOverlap>
                  + Inspection Cost ({Number(claimDetails?.inspectionHours).toFixed(2)} Hours):
                </PDFText>
              </View>
              <View>
                <PDFText style={styles.text}>{formateAmount(claimDetails?.inspectionCost)}</PDFText>
              </View>
            </PDFRow>
            <PDFRow>
              <View style={{ width: 135 }}>
                <PDFText style={styles.title2}>
                  + Interest Expense ({Number(`${claimDetails?.claimInterestRate}1`).toFixed(2)} %):
                </PDFText>
              </View>
              <View>
                <PDFText style={styles.text}>{formateAmount(claimDetails?.interestExpense)}</PDFText>
              </View>
            </PDFRow>
            <PDFRow>
              <View style={{ width: 135 }}>
                <PDFText style={styles.title2}>+ Documentation Cost :</PDFText>
              </View>
              <View>
                <PDFText style={styles.text}>{formateAmount(claimDetails?.claimAdminCharge)}</PDFText>
              </View>
            </PDFRow>
            <PDFRow>
              <View style={{ width: 135 }}>
                <PDFText style={styles.title2}>+ Taxes:</PDFText>
              </View>
              <View>
                <PDFText style={styles.text}>{formateAmount(claimDetails?.claimTaxAmount)}</PDFText>
              </View>
            </PDFRow>
            <PDFRow>
              <View style={{ width: 135 }}>
                <PDFText style={styles.title2}>- Deductible Amount :</PDFText>
              </View>
              <View>
                <PDFText style={styles.text}>{formateAmount(claimDetails?.claimDeductibleAmount)}</PDFText>
              </View>
            </PDFRow>
            <PDFRow>
              <View style={{ width: 135 }}>
                <PDFText style={styles.title2}>- Credit Amount :</PDFText>
              </View>
              <View>
                <PDFText style={styles.text}>{formateAmount(claimDetails?.claimCreditAmount)}</PDFText>
              </View>
            </PDFRow>
            <PDFRow>
              <View style={{ width: 135 }}>
                <PDFText style={{ ...styles.title2, paddingLeft: 5 }}>CLAIM AMOUNT DUE :</PDFText>
              </View>
              <View>
                <PDFText style={styles.text}>
                  {formateAmount(claimDetails?.claimTotal)} {claimDetails?.currencyCode}
                </PDFText>
              </View>
            </PDFRow>
          </View>
        </View>
        <View style={{ marginBottom: 5, marginTop: 15 }}>
          <PDFText style={styles.title2}>
            INDEMNITY AGREEMENT: The claimant agrees to protect the Transportation Provider and its connections against
            any loss from nonsurrender Of the Original Freight Bill, Original Bill Of Lading, or Both.
          </PDFText>
        </View>
        <View
          style={{
            border: '1px solid black',
            display: 'flex',
            flexDirection: 'row',
          }}
        >
          <View style={{ flex: 1, borderRight: '1px solid black', padding: 3 }}>
            <PDFText style={{ ...styles.title2, fontSize: 6 }}>
              The following documents are submitted in support of this claim :
            </PDFText>
            <PDFText style={{ ...styles.title2, fontSize: 6 }}>
              __ Bill of Lading ______ Freight Bill ______ Invoice ______
            </PDFText>
            <PDFText style={{ ...styles.title2, fontSize: 6 }}>Other _____________________________ :</PDFText>
          </View>
          <View style={{ flex: 1, padding: 3, paddingTop: 6 }}>
            <PDFText style={{ ...styles.title2, fontSize: 6 }}>
              The foregoing statement of facts is hereby certified to be correct :
            </PDFText>
            <PDFText style={{ ...styles.title2, fontSize: 6 }}>
              Claim Prepared By {claimDetails?.preparedBy} ({claimDetails?.emailOfPreparedBy})
            </PDFText>
          </View>
        </View>
      </View>
    </PDFPage>
  );
};

const styles = StyleSheet.create({
  header: { paddingHorizontal: 10, paddingVertical: 5 },
  // @ts-ignore TODO: possible bug: fontWeight for LADClaimPDF
  title: { fontSize: 10, fontWeight: '700' },
  // @ts-ignore
  title2: { fontSize: 8, fontWeight: '700' },
  // @ts-ignore
  text: { fontSize: 8, fontWeight: '400', textOverflow: 'ellipsis' },
  headerRow: {
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  section: {
    paddingHorizontal: 5,
    paddingVertical: 10,
  },
  imageSection: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    paddingVertical: 10,
  },
  image: {
    width: '60%',
  },
  tableHeader: {
    // @ts-ignore
    fontWeight: '700',
    fontSize: 8,
    textAlign: 'center',
  },
  tableCol: {
    fontSize: 8,
  },
});

export default LADClaimPDF;
